import React from 'react';
import ReactDOM from 'react-dom';

import ModalAnnouncement from '../app/components/modals/ModalAnnouncement.jsx';

const root = document.getElementById('ann-modal');

if (root) {
  ReactDOM.render((
    <ModalAnnouncement path="home" />
  ), root);
}
